import React from "react";
import photoStyles from "../page/Projekte.module.css";

const Projekte = () => {
    const gesundheitstage = [

        "/assets/projekte/Gesundheitstage/f1d90f_35692b186e314de2a15b73f4d95e67c7~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_63272eb49ce1438cbcdf7e109308d83f~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_963886e732be4713a93d2a557ef5fb3e~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_0293199079864eb282d7e8c2f3665b9c~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_a0cbe96f9b94472ea27d3710910f26e3~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_a024a76538e44226989d72a8946166d6~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_d3f5f18a09c94a1e8fda2df5efff4f5a~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_1e1b77c021e34144bd0061f4caf23813~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_21931d77aa864e1290b4f6aff7112c57~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_d4e5850dc97245e99c1980ab9ec3de4a~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_ec49807f18664588987fc6142b49f71d~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_0b935c98e64e49aca10c852e5cafa4d5~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_2b64b70b569044f590d714fc3cbec227~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_3a2332513ac14193bbf804503a6bb1db~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_7c40bc09b6af48b98bf82cbe291a6af4~mv2.avif",
        "/assets/projekte/Gesundheitstage/f1d90f_47a9e924754b4a54b292e5a10efef0be~mv2.avif"
    ];

    const interkulturelleProjektwoche =[
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_2e518267423b448ebe554dcb92a60daf~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_6e5a34872cd548ad9f2edfca24527d46~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_8be3f9e648a846d89727e9f1cdc5ae73~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_9c68c088f1944422a8cebb094c94268d~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_9cd355e1412a4115ab20ea84a5b7a859~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_014cc5015e3d4a18b49c76b4d46bc398~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_677e8cf077c34a98891cacd58f2bb3b4~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_11350c4001d84b16a0dd905bbf71a839~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_a9b42443a75c4d83bfd7f9a96aeb5e4c~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_a22e413aab644d88bce9827658fae211~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_a264aa8758c74b26922cd3044dfa2870~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_bd7dee71cb014b4794ff88d845237143~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_d7abd17851cc48d3b1a61c6024d572cb~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_e1ccffc3f0b24395ac4e140a1bfdf4d4~mv2.avif",
        "/assets/projekte/InterkulturelleProjektwoche/f1d90f_e8b74b3668cc4500b47cfec2095ff4d5~mv2.avif"
    ];

    const verkehrserziehung =[
        "/assets/projekte/Verkehrserziehung/f1d90f_4cb793b3a69a49418611334ed0e5e232~mv2.avif",
        "/assets/projekte/Verkehrserziehung/f1d90f_be34fe8e3f494b83a3e8866de6978d55~mv2.avif"
    ];

    const gesundeErnährung =[
        "/assets/projekte/GesundeErnährung/f1d90f_17c364220b75480a910200acefd697e6~mv2.avif",
        "/assets/projekte/GesundeErnährung/f1d90f_77b4dc37f5e4419bb5f07e7bf19a5949~mv2.avif",
        "/assets/projekte/GesundeErnährung/f1d90f_f883f6a8895f43d8b0aab9e2e94a0018~mv2.avif",
        "/assets/projekte/GesundeErnährung/f1d90f_ffc4fc46522548b79ef3e14f0537df1b~mv2.avif"
    ];

    const zahngesundheit =[
        "/assets/projekte/Zahngesundheit/f1d90f_8ecf53545aad40cfa49683e6fe602356~mv2.avif",
        "/assets/projekte/Zahngesundheit/f1d90f_62fcb46431a64ec99eac2d6ea71ce1b2~mv2.avif",
        "/assets/projekte/Zahngesundheit/f1d90f_b0379adef3df42afb97489b5ab2f9057~mv2.avif"
    ]



    return (
        <main className="wrapper wrapperContent">
            <section className={photoStyles.section}>
                <div className={photoStyles.text}>
                    <h1>PROJEKTE</h1>
                    <p>
                        Für ein ganzheitliches Lernen mit allen Sinnen ermöglichen wir unseren
                        Schüler/innen in allen Jahrgangsstufen verschiedene Projekte, die
                        thematisch aus der Lebenswelt der Kinder hervorgehen und einen hohen
                        Motivationscharakter für das Lernen mitbringen.
                    </p>
                    <h2>Gesundheitstage</h2>
                    <p>
                        Am ersten Tag zeigte uns die Umweltpädagogin Sabine Heruday mit ihrem
                        Projekt „Komm lass uns rausgehen“, wie viel Spaß man mit und in der Natur
                        erleben kann. Bewusste Wahrnehmung, Bewegung und Kreativität standen an
                        diesem Tag an erster Stelle!
                    </p>
                </div>

                <div className={photoStyles.galleryContainer}>
                    <div className={photoStyles.photoGrid}>
                        {gesundheitstage.map((photo, index) => (
                            <div key={index} className={photoStyles.photoItem}>
                                <img src={photo} alt={`Photo ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>

                <div className={photoStyles.text}>
                    <h2>Interkulturelle Projektwoche</h2>
                    <p>An jedem Projekttag gab es über die genannten Kulturkreise viel zu erfahren! Ob kulinarische Genüsse, Musik, Tanz und Bekleidung, sowie traditionelle Spielevielfalt: in Workshops zum Anfassen und Mitmachen lernte es sich mit viel Spaß! Die Interkulturelle Projektwoche war für alle Beteiligten ein sehr abwechslungsreiches Erlebnis. „Wir lieben Vielfalt“, das Motto der IKS Schule, war in jedem Moment dieser Woche spürbar. Jedes Kind konnte sich mit Erfahrungen und Traditionen aus der eigenen Familie einbringen, und natürlich ebenso die Lehrkräfte!</p>

                </div>
                <div className={photoStyles.galleryContainer}>
                    <div className={photoStyles.photoGrid}>
                        {interkulturelleProjektwoche.map((photo, index) => (
                            <div key={index} className={photoStyles.photoItem}>
                                <img src={photo} alt={`Photo ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className={photoStyles.text}>
                    <h2>Verkehrserziehung</h2>
                    <p>Ob Indoor mit einem Parcours oder Outdoor im Spaziergang um den Block: Verkehrserziehung ist auch schon in der 1. Klasse ein wichtiges Thema! Mit freundlicher Unterstützung des ADACs, sowie der Stadtpolizei ließen sich Verhaltens- und Verkehrsregeln verständlich und praxisnah erlernen.</p>
                </div>
                <div className={photoStyles.galleryContainer}>
                    <div className={photoStyles.photoGrid}>
                        {verkehrserziehung.map((photo, index) => (
                            <div key={index} className={photoStyles.photoItem}>
                                <img src={photo} alt={`Photo ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className={photoStyles.text}>
                    <h2>Gesunde Ernährung</h2>
                    <p>In den Klassen wurden gesunde Frühstücksrezepte ausgewählt und gemeinsam zubereitet. Die Zutaten wurden gemeinsam eingekauft. Natürlich werden die Speisen dann zur Frühstückspause auch von allen gekostet! Auch die Eltern waren zu einer Kostprobe herzlich eingeladen!</p>
                </div>
                 <div className={photoStyles.galleryContainer}>
                    <div className={photoStyles.photoGrid}>
                        {gesundeErnährung.map((photo, index) => (
                            <div key={index} className={photoStyles.photoItem}>
                                <img src={photo} alt={`Photo ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className={photoStyles.text}>
                    <h2>Zahngesundheit</h2>
                    <p>Zum Abschluss der Gesundheitstage besuchte uns eine Zahnärztin in der Schule. In einem Workshop wurden den Kindern auf anschauliche Weise Themen, wie Zahngesundheit, Mundhygiene und Zahnpflege, näher gebracht. Anschließend wurden alle Kinder von der Zahnärztin untersucht und sie bekamen eine Urkunde.</p>

                </div>
                    <div className={photoStyles.galleryContainer }>
                        <div className={photoStyles.photoGrid}>
                            {zahngesundheit.map((photo, index) => (
                                <div key={index} className={photoStyles.photoItem}>
                                    <img src={photo} alt={`Photo ${index + 1}`} />
                                </div>
                            ))}
                        </div>
                    </div>
            </section>

        </main>
    );
};

export default Projekte;
